module.exports = __webpack_public_path__ + "img/LifeFM.a1aabf29.png";